import { Module } from '#/shared/types';
import {
  NotificationSetting,
  NotificationSettingValue,
  NotificationType
} from '#/entities/notification-setting';

export type NotificationSettingDTO = {
  NotificationType: NotificationType;
  NotificationEnableType: NotificationSettingValue;
  Source: Module;
};

export const dtoToNotificationSetting = (dto: NotificationSettingDTO[]): NotificationSetting[] => {
  return dto.map((item) => ({
    id: item.NotificationType,
    notificationType: item.NotificationType,
    value: item.NotificationEnableType,
    source: item.Source
  }));
};

export const notificationSettingToDTO = (
  notificationSetting: NotificationSetting
): NotificationSettingDTO => {
  return {
    NotificationType: notificationSetting.notificationType,
    NotificationEnableType: notificationSetting.value,
    Source: notificationSetting.source
  };
};
